import { ReactElement } from 'react'
import { SvgIcon } from '@mui/material'
import Icon from 'src/assets/icons/select-wall.svg?react'

const Wall = (): ReactElement => {
  return <SvgIcon component={Icon} inheritViewBox />
}

export default Wall
